import { AnimatePresence } from "framer-motion";
import { useMemo } from "react";

import { useRankifierState } from "../../../hooks/useRankifierState";
import { RankifierCard } from "../RankifierCard";

export interface CardsListProps {
  cardReverseImage: string;
}

export const CardsList = ({ cardReverseImage }: CardsListProps) => {
  const [
    {
      status: { round },
      game: {
        configuration: { cardsPerHand },
      },
      cards: { all: cards },
    },
  ] = useRankifierState();

  const cardsToRender = useMemo(() => cards.slice(0, (round + 1) * cardsPerHand), [cards, cardsPerHand]);

  return (
    <AnimatePresence>
      {cardsToRender.map(
        (card, index) =>
          card && (
            <RankifierCard
              key={card?.index}
              index={index}
              totalCards={cards.length}
              card={card}
              reverseImage={cardReverseImage}
              // Only animate the first hand
              skipInitialAnimation={index >= cardsPerHand}
            />
          ),
      )}
    </AnimatePresence>
  );
};
